import { takeEvery, call, put, select } from 'redux-saga/effects';
import { isEmptyObject, safeGet } from '../core/util/object';
import { apiGet } from '../core/dapi';
import { getIsInMarketPlaceUrl } from '../core/dapi/detect';
import { setIsInMarketPlaceSearch } from '../actions/searchPreferences';
import { isEmpty } from '../core/util/empty';
import logger from '../core/logger';
import { isClientSide, isServerSide } from '../core/util/system';
import { analyticsTagHotjarRecording, analyticsTriggerHotjarRecording } from '../core/analytics';
import { MARKETPLACE_DFW } from '../constants';
import { HOTJAR_TRACKING_LABEL } from '../core/tracking/hotjar/constants';

const DETECT_IF_USER_IN_MARKER = 'saga/DETECT_IF_USER_IN_MARKET';

export function detectIfUserIsInMarket(payload, override = false) {
  return {
    type: DETECT_IF_USER_IN_MARKER,
    location: payload,
    override,
  };
}

function* handleDetect(value) {
  const location = value.location;
  const override = value.override;
  const userPositionInState = yield select(state => safeGet(state, {})('position.result'));
  const searchPrefererenceLocationInState = yield select(state =>
    safeGet(state, {})('searchPreferences.location')
  );

  const isInMarketPlace = yield select(state =>
    safeGet(state, null)('searchPreferences.isInMarketPlaceSearch')
  );

  if (isEmpty(isInMarketPlace) || override) {
    let locationOfIntent = location;
    if (isEmptyObject(locationOfIntent)) {
      if (!isEmptyObject(searchPrefererenceLocationInState)) {
        locationOfIntent = searchPrefererenceLocationInState;
      } else {
        locationOfIntent = userPositionInState;
      }
    }

    if (!isEmptyObject(locationOfIntent)) {
      const latitude = locationOfIntent.latitude;
      const longitude = locationOfIntent.longitude;
      const url = getIsInMarketPlaceUrl(latitude, longitude);
      const response = yield call(apiGet, url);
      const userInMarketplace = safeGet(response, false)('in_market');
      if (userInMarketplace) {
        analyticsTagHotjarRecording([MARKETPLACE_DFW, HOTJAR_TRACKING_LABEL.detect]);
        analyticsTriggerHotjarRecording(MARKETPLACE_DFW);
      }
      yield put(setIsInMarketPlaceSearch(response));
    }
  } else {
    logger.debug(
      'Detect if user in market skipped because existing location in state ' +
        'and no override was passed'
    );
  }
}

function* rootSaga() {
  yield takeEvery(DETECT_IF_USER_IN_MARKER, handleDetect);
}

export { DETECT_IF_USER_IN_MARKER, rootSaga as default };
